<template>
  <div class="partnershipMobileCardsContainer">
    <PartnershipMobileCard
      v-for="(partner, index) in partnerTableDataMap"
      :key="index"
      class="mb-4"
      :index="index"
      :partner="partner"
    />
  </div>
</template>

<script>
import { partnerTableDataMap } from '../constants/authenticatorsConstants';
import PartnershipMobileCard from './PartnershipMobileCard';

export default {
  name: 'PartnershipMobileCards',
  components: {
    PartnershipMobileCard
  },
  data() {
    return {
      partnerTableDataMap
    };
  }
};
</script>
